// Mapeia as respostas (JSON:API, atributos dasherizados) dos endpoints de
// /reports/live_challenges/* para o formato já consumido pelos componentes
// desta tela. Ver doc em .claude/tasks/prd-relatorio-desafio-ao-vivo/ (ou o
// arquivo de referência manual dos endpoints) para o contrato completo.
import moment from 'moment';

export const TEACHERS_PER_PAGE = 20;
export const CHALLENGES_PER_PAGE = 20;

export function buildDateQuery(startDate, endDate) {
  return { initial_date: startDate, end_date: endDate };
}

export function buildUsageChartData(chartData = []) {
  return {
    categories: chartData.map(item => moment(item['period-start']).format('DD/MM/YY')),
    series: [{ label: 'Aplicações por período', color: '#3956F5', data: chartData.map(item => item.count) }]
  };
}

export function mapGreDistribution(distribution = []) {
  return distribution.map(item => ({ name: item['regional-name'], value: item.count }));
}

export function mapSubjectDistribution(distribution = []) {
  return distribution.map(item => {
    const activationsCount = item['activations-count'] ?? 0;
    const accuracyPercentage = item['accuracy-percentage'] ?? 0;
    // Fracionário de propósito — não arredondar pra inteiro. Com poucas
    // ativações (ex.: 2), Math.round distorce a proporção visual da barra
    // (66,67%/33,33% virava 1/1 = 50%/50%). O echarts empilha floats sem
    // problema, então correct+incorrect continuam somando activationsCount
    // exatamente na mesma proporção do %.
    const correct = activationsCount * (accuracyPercentage / 100);
    return {
      subject: item['subject-name'],
      correct,
      incorrect: activationsCount - correct,
      // % pooled de acerto/erro vindas direto da API, usadas no tooltip.
      accuracyPercentage: item['accuracy-percentage'],
      errorPercentage: item['error-percentage']
    };
  });
}

export function mapTeachers(teachers = []) {
  return teachers.map(teacher => ({
    id: teacher.id,
    name: teacher.name,
    email: teacher.email,
    gre: teacher['regional-name'],
    institution: teacher['institution-name'],
    activations: teacher['activations-count'],
    avatar: null
  }));
}

function mapActivation(activation) {
  return {
    id: activation.id,
    label: `#${activation.position}`,
    date: activation['started-at'],
    participants: activation['participants-count'],
    accuracyPercent: activation['accuracy-percentage']
  };
}

export function mapChallenges(challenges = []) {
  return challenges.map(challenge => ({
    id: challenge.id,
    title: challenge.title,
    subject: challenge['subject-name'],
    createdByTeacher: challenge.creator,
    activations: challenge['activations-count'],
    avgParticipants: challenge['average-participants'],
    avgAccuracyPercent: challenge['accuracy-percentage'],
    lastActivationAt: challenge['last-activation-at'],
    activationsList: (challenge.activations || []).map(mapActivation)
  }));
}

export function mapRanking(ranking = []) {
  return ranking.map(student => ({
    id: student['participant-id'],
    position: student.position,
    name: student.name,
    email: student.email,
    institutionCourse: student.institution,
    classroom: student.classroom,
    points: student.score
  }));
}
